import { useState } from 'react';

import { CancelSurvey } from '../../components/CancelSurvey/CancelSurvey';

import type { UseCancelModalParams } from './useCancelModal.types';

export const useCancelModal = ({
  cancellationReasons,
  screenName,
}: UseCancelModalParams) => {
  const [isSurveyOpen, setIsSurveyOpen] = useState(false);
  const openModal = () => setIsSurveyOpen(true);
  const dismissModal = () => setIsSurveyOpen(false);

  const modal = isSurveyOpen && (
    <CancelSurvey
      isOpen={isSurveyOpen}
      onClose={dismissModal}
      reasons={cancellationReasons}
      cancelScreenName={screenName}
    />
  );

  return {
    isSurveyOpen,
    openModal,
    dismissModal,
    modal,
  };
};
